/* eslint-disable */
import { Injectable } from '@angular/core';
import { TimeService } from './time.service';
import { CookieService } from 'angular2-cookie/core';
import moment from 'moment';

@Injectable()
export class RouteParamsHandler {
  constructor (timeService: TimeService, cookies: CookieService) {
    this.timeService = timeService;
    this.cookies = cookies;
  }

  checkRouteParams(location) {
    let params = '';
    if (location.search) {
      params = location.search;
    } else {
      params = location.hash.substring(location.hash.indexOf('?'));
    }

    if (params.toLowerCase().indexOf('adtrk') >= 0) {
      this._setAdtrk(params);
    }

    this._setUrlParameters();
  }

  _setAdtrk(adtrk) {
    //get current cookie and if not instantiate cookieMonster with a empty string
    let cookieMonster = this.getCookie('ADTRK');
    //set day for new adtrk
    adtrk = `${adtrk}|${this.timeService.getCurrentDateMin()}`;
    //if there is a cookie
    if (cookieMonster) {
      //check if this adtrk has already exists with todays date and hour
      if (cookieMonster.indexOf(adtrk) < 0){
        //add it to the current cookie variable
        cookieMonster = `${cookieMonster}||${adtrk}:${this.timeService.getCurrentMinSec()}`;
      }
      //if it already contains this adtrk then don't do anything
      else if (cookieMonster.indexOf(adtrk) >= 0) {
        return;
      }
    } else {
      //set cookieMonster to the adtrk and add the seconds and minutes
      cookieMonster = `${adtrk}:${this.timeService.getCurrentMinSec()}`;
    }
    //set cookie
    this._setCookie('ADTRK', cookieMonster);
  }

  _setUrlParameters() {
    let urlParams = location.search;

    if (urlParams.indexOf('?CP') === 0) {
      urlParams = urlParams.slice(4);
      this._setCookie('CP', decodeURIComponent(urlParams));
    }

    if (urlParams.indexOf('?engine') === 0) {
      urlParams = urlParams.slice(1);
      this._setCookie('urlparameters', urlParams);
    }
  }

  getCookie(name) {
    //get all cookies in a key value object
    let cookies = this.cookies.getAll(); // this is object with key value pair
    if (cookies[name]) {
      return cookies[name];
    } else {
      //if no cookie matches return an empty string
      return '';
    }
  }

  _setCookie(name, cookieValue) {
    //set cookie to expire 60 days later from today
    this.cookies.put(name, cookieValue, {
      expires: moment().add(60, 'days').toDate()
    });
  }
}